module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Fragebogen.e1c54472.svg";